// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-side_navigation__cf3m7","navigationItem":"navigation-side_navigationItem__dWNqp"};